
export default {
    loadFiles: (id) => {
        return fetch('/list/files/'+id, {
            method: 'GET',
            headers: {
                "content-type": "application/json"
            }
        })
    },
    submitFiles : async (formData) => {
        return fetch('/upload', {
            method: 'POST',
            body: formData
        })
        .then(async (response) => {
            let data = await response.json()
            return data;
        })
        .catch(error => {
            console.error(error);
            return error;
        })
    },
    removeImage : async (file) => {
        return fetch('/delete/file', {
            method: 'POST',
            body: JSON.stringify({url: file.url}),
            headers: {
                "content-type": "application/json"
            }
        })
        .then(async (response) => {
            return await response.json()
        })
        .catch(error => {
            console.error(error);
            return error;
        })
    },
    
    removeAllFiles: async (urls) => {
        return fetch('/deleteAll/files', {
            method: 'POST',
            body: JSON.stringify({urls: urls}),
            headers: {
                "content-type": "application/json"
            }
        })
        .then(async (response) => {
            return await response.json()
        })
        .catch(error => {
            console.error(error);
            return error;
        })
    }
}